import Modal from 'react-modal';
import './login.css';
import successTick from './icons/successTick.png'
import successCancel from './icons/successCancel.png'
import PropTypes from 'prop-types';

const customStyles = {
    overlay:{
      backgroundColor: 'transparent',
    },
  }

const SuccessPopup = ({ isOpen, onRequestClose, message }) => (
  <Modal
    isOpen={isOpen}
    onRequestClose={onRequestClose}
    className='successpopbody'
    ariaHideApp={false}// This is added to prevent a11y warnings, adjust as needed
    style={customStyles}
  >
    <div className='successpopup'>
    <div style={{display:"flex",
         justifyContent:"space-between",
         alignItems:"center",
         color:"#FFFFFF"}}  ><img alt="" src={successTick} style={{height:"45px",
         width:"50px"}}></img>
      <p style={{fontSize:"20px"}}>{message}</p>
      <button onClick={onRequestClose} style={{border:"none",backgroundColor:"#6D9335"}}>
        <img alt="" src={successCancel}></img>
        </button>
    </div>
    </div>
  </Modal>
);

SuccessPopup.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired,
};

export default SuccessPopup;